import type { CustomerKind } from "@erp/shared";
import { queryOptions } from "@tanstack/react-query";
import type { BadgeTone } from "~/components/ui/badge";
import { api, unwrap } from "~/lib/api";

export const KIND_TONE: Record<CustomerKind, BadgeTone> = { individual: "neutral", business: "info", public: "gold" };

export const customerQuery = (id: string) =>
  queryOptions({ queryKey: ["customers", id], queryFn: () => unwrap(api.customers({ id }).get()) });

export type CustomerDetail = Awaited<ReturnType<NonNullable<ReturnType<typeof customerQuery>["queryFn"]>>>;
